var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var log_level_1 = require("../const/log.level");
var appender_1 = require("../decorator/appender");
var virtual_console_1 = require("../util/virtual.console");
var log_appender_1 = require("./log.appender");
var ConsoleAppender = /** @class */ (function (_super) {
    __extends(ConsoleAppender, _super);
    function ConsoleAppender() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Appends the log event
     * @param {ILogEvent} logEvent
     */
    ConsoleAppender.prototype.append = function (logEvent) {
        if (logEvent.level <= this.getLogLevel()) {
            this._appendToConsole(logEvent);
        }
    };
    /**
     * @private
     * @function
     *
     * @param {ILogEvent} logEvent
     */
    ConsoleAppender.prototype._appendToConsole = function (logEvent) {
        var message = this.format(logEvent);
        switch (logEvent.level) {
            case log_level_1.LogLevel.FATAL:
            case log_level_1.LogLevel.ERROR: {
                if (logEvent.error) {
                    virtual_console_1.getVirtualConsole().error(message, logEvent.error);
                }
                else {
                    virtual_console_1.getVirtualConsole().error(message);
                }
                break;
            }
            case log_level_1.LogLevel.WARN: {
                virtual_console_1.getVirtualConsole().warn(message);
                break;
            }
            case log_level_1.LogLevel.INFO: {
                virtual_console_1.getVirtualConsole().info(message);
                break;
            }
            case log_level_1.LogLevel.DEBUG:
            case log_level_1.LogLevel.TRACE: {
                virtual_console_1.getVirtualConsole().debug(message);
                break;
            }
            default:
                break;
        }
    };
    ConsoleAppender = __decorate([
        appender_1.Appender('Console')
    ], ConsoleAppender);
    return ConsoleAppender;
}(log_appender_1.LogAppender));
exports.ConsoleAppender = ConsoleAppender;
